// Confirm all values with the design team before finalising.
export const buttons = {
  /* Primary Colors */
  primaryButtonBackgroundColor: '#604099', // Hallmark purple
  /* Secondary Colors */
  secondaryButtonBorderColor: '#604099', // Same as primary
  // NOTE: secondaryButtonBackgroundColor is intentionally omitted — crown-ui sets it to white globally
  /* Disabled State */
  primaryButtonDisabledBorderColor: '#BDBDBD', // medium-gray
  primaryButtonDisabledBackgroundColor: '#293035', // darker gray (used on hover)
  /* Border */
  borderColor: '#604099', // light-gray
};
